import { useEffect, useRef } from 'react';
import { setHeight } from './wix';

/** Keeps the Wix iframe exactly as tall as the element the returned ref is attached to. */
export function useAutoHeight<T extends HTMLElement>() {
    const ref = useRef<T>(null);

    useEffect(() => {
        const element = ref.current;
        if (!element) return;
        let last = -1;
        let frame = 0;
        const report = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                const height = Math.ceil(element.getBoundingClientRect().height);
                if (height !== last) setHeight((last = height));
            });
        };
        const observer = new ResizeObserver(report);
        observer.observe(element);
        report();
        return () => {
            observer.disconnect();
            cancelAnimationFrame(frame);
        };
    }, []);

    return ref;
}
